export const WIKI_TRANSITION_TIME = 300
